import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { Locker } from 'src/app/models/locker.model';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { images } from 'src/app/resources/images';
import { DialogCloseResult, DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { Router } from '@angular/router';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { Site } from 'src/app/models/site.model';
import { LockersFormComponent } from '../lockers-form/lockers-form.component';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SharingService } from 'src/app/services/sharing.service';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { LockersDetailsComponent } from '../lockers-details/lockers-details.component';
import { LockersEditComponent } from '../lockers-edit/lockers-edit.component';



@Component({
    selector: 'app-lockers-component',
    templateUrl: './lockers.component.html'
})
export class LockersComponent implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public gridData: Locker[] = [];
    public gridView: any[] = [];
    public filter: CompositeFilterDescriptor | undefined;
    public mySelection: string[] = [];
    public customMsgService: CustomMessagesService;

    constructor(private sharingService: SharingService,
        public msgService: MessageService, private dialogService: DialogService, private router: Router, private api: ApiService, private notificationService: NotificationService,) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.allData = this.allData.bind(this);
    }

    public ngOnInit(): void {
        this.gridView = this.gridData;
        this.load();
    }

    // Update Grid collection during changing My Team/All Team
    public onTeamChange(pageSize: number): void {
        pageSize === 25
            ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
            : (this.gridView = this.gridData.slice(0, pageSize));
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;

        this.dataBinding ? this.dataBinding.skip = 0 : null;
    }

    public getField = (args: Locker) => {
        return `${args.nome}_$`;
    }

    public photoURL(dataItem: any): string {
        const code: string = dataItem.imgId + dataItem.gender;
        const image: any = images;

        return image[code];
    }

    public flagURL(dataItem: any): string {
        const code: string = dataItem.country;
        const image: any = images;

        return image[code];
    }

    public showConfirmation(): void {
    }

    //botão de estado de armario
    public openEstadoArmario(l: Locker): void {
        this.sharingService.sharingValue = l;
        const dialogRef = this.dialogService.open({
            title: this.customMsgService.translate('estadoDoArmario') + " - " + l.nome,
            content: LockersDetailsComponent,
        });
    }

    //botão de editar estado do armario
    public openEditEstadoArmario(l: Locker): void {
        this.sharingService.sharingValue = l;
        const dialogRef = this.dialogService.open({
            title: this.customMsgService.translate('precoHora') + " - " + l.nome,
            content: LockersEditComponent,
        });
    }

    load() {
        this.gridView = this.gridData;
        this.api
            .getRequest<BaseHttpResponse<Locker[]>>("Armario/GetArmarios")
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });
    }

    public open(): void {
        const dialogRef: DialogRef = this.dialogService.open({

            title: this.customMsgService.translate('btnCriar') + " " + this.customMsgService.translate('armario'),
            // Show component
            content: LockersFormComponent
        });

        dialogRef.result.subscribe((result) => {
            this.gridView = this.gridData;
            this.api
                .getRequest<BaseHttpResponse<Locker[]>>("Armario/GetArmarios")
                .then((data) => {
                    this.gridData = data.value;
                    this.gridView = this.gridData;
                })
                .catch((err) => { });
        });
    }

    public openEdit(c: Locker): void {
        const dialogRef: DialogRef = this.dialogService.open({
            title: this.customMsgService.translate('btnEditar') + " " + this.customMsgService.translate('armario'),
            // Show component
            content: LockersFormComponent
        });

        const userInfo = dialogRef.content.instance as LockersFormComponent;
        let i = 1;
        c.modulos.forEach(element => {
            element.internalID = i;
            i++;
        });
        userInfo.formValue = c;
        userInfo.setFormValues();
        dialogRef.result.subscribe((result) => {
            this.gridView = this.gridData;
            this.api
                .getRequest<BaseHttpResponse<Locker[]>>("Armario/GetArmarios")
                .then((data) => {
                    this.gridData = data.value;
                    this.gridView = this.gridData;
                })
                .catch((err) => { });
        });
    }

    canlist() {
        return User.canArmariosList();
    }

    canCreate() {
        return User.canArmariosCreate();
    }

    canEdit() {
        return User.canArmariosEdit();
    }

    canDelete() {
        return User.canArmariosDelete();
    }

    canAssociacaoList() {
        return User.canAssociacaoArtigosPorArmarioList();
    }

    canAssociacaoEdit() {
        return User.canAssociacaoArtigosPorEquipaEdit();
    }

    public delete(e: Site): void {
        var sim = this.customMsgService.translate('yes');
        var nao = this.customMsgService.translate('no');
        const dialog: DialogRef = this.dialogService.open({
            appendTo: this.container,
            title: this.customMsgService.translate('confirmacao'),
            content: this.customMsgService.translate('desejaRemover'),
            actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
            width: 450,
            height: 200,
            minWidth: 250,
        });
        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
            } else if (result.text == sim) {
                this.api.cruddelete<BaseHttpResult>('Armario', e.id).
                    then(res => {
                        if (res.ok) {
                            this.notificationService.show({
                                appendTo: this.container,
                                content: this.customMsgService.translate('registoApagadoComSucesso'),
                                animation: { type: 'slide', duration: 500 },
                                position: { horizontal: 'center', vertical: 'top' },
                                type: { style: 'success', icon: true },
                                hideAfter: 2000
                            });
                            this.load();
                        } else {
                            this.notificationService.show({
                                appendTo: this.container,
                                content: res.message,
                                animation: { type: 'slide', duration: 500 },
                                position: { horizontal: 'center', vertical: 'top' },
                                type: { style: 'error', icon: true },
                                hideAfter: 4000
                            });
                        }
                    }).
                    catch(err => {
                    });
            }
        });
    }

    public allData(): ExcelExportData {
        const result: ExcelExportData = {
            data: process(this.gridView, { filter: this.filter }).data,
        };
        return result;
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.gridView, filter);
    }
}
